import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Header } from "semantic-ui-react";

import ErrorBoundary from "../../components/errorBoundaries/ErrorBoundary.jsx";
import RegistrationForm from "../../components/sentry/RegistrationForm.jsx";
import LinkWithReset from "../../components/utils/LinkWithReset.jsx";

import {
  createUser,
  resetUserSignUp
} from "../../state/reducers/signup/signUpActions.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";
import { ROUTES } from "../../constants/routing.js";

class RegisterMarketplace extends PureComponent {
  static propTypes = {
    copy: PropTypes.func.isRequired
  };

  componentWillUnmount() {
    this.props.resetUserSignUp();
  }

  // -- HANDLERS -- //

  constructor(props) {
    super(props);

    const { provider, token } = props.match.params;

    this.state = {
      provider,
      token
    };
  }

  onReset = () => {
    // used to force render via key on main Container
    this.props.resetUserSignUp();
  };

  onSubmit = values => {
    const { provider } = this.state;
    const { token } = this.state;
    const data = {
      marketplaceProvider: provider,
      marketplaceToken: decodeURIComponent(token), // encoded in the edge rewrite
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      emailConfirmation: values.emailConfirmation,
      username: values.username,
      password: values.password,
      passwordConfirmation: values.passwordConfirmation
    };
    this.props.createUser(data);
  };

  // -- RENDER -- //

  render() {
    const { provider } = this.state;
    const { token } = this.state;
    const { copy } = this.props;

    var title = copy("sentry.register_marketplace.title");
    var title = title.replace(/\*marketplaceProvider/g, provider.toUpperCase());

    var description = copy("sentry.register_marketplace.description");
    description = description.replace(
      /\*marketplaceProvider/g,
      provider.toUpperCase()
    );

    var existingURL = "".concat(
      ROUTES.MARKETPLACE_LOGIN,
      "/",
      provider.toLowerCase(),
      "/",
      token
    );

    return (
      <div className="sentry-form">
        <Header as="h3" inverted textAlign="center">
          {copy("sentry.register.title")}
        </Header>

        <div>
          <div class="ui small icon info message segment-message clear-both">
            <i aria-hidden="true" class="cloud icon"></i>
            <div class="content">
              <div class="header">{title}</div>
              <p>{description}</p>
            </div>
          </div>
        </div>

        <ErrorBoundary>
          <RegistrationForm onReset={this.onReset} onSubmit={this.onSubmit} />
          <footer>
            <LinkWithReset to={existingURL}>
              {copy("sentry.register.marketplace_login_cta")}
            </LinkWithReset>
          </footer>
        </ErrorBoundary>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  createUser: data => dispatch(createUser(data)),
  resetUserSignUp: () => dispatch(resetUserSignUp())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterMarketplace);
